import React from 'react';
import { Chip } from '@mui/material';

const COLORS = {
  draft:                'default',
  review:               'info',
  active:               'success',
  paused:               'warning',
  completed:            'info',
  archived:             'default',
  ACTIVE:               'success',
  COMPLETED:            'info',
  STOPPED_REPLIED:      'warning',
  STOPPED_PAUSED:       'warning',
  INVALID:              'error',
  SKIPPED:              'default',
  FAILED:               'error',
  PENDING:              'default',
  SCHEDULED:            'default',
  SENDING:              'info',
  SENT:                 'info',
  DELIVERED:            'info',
  OPENED:               'info',
  REPLIED:              'warning',
  BOUNCED:              'error',
  healthy:              'success',
  warming:              'warning',
  token_expired:        'error',
};

const LABEL = {
  STOPPED_REPLIED: 'replied',
  STOPPED_PAUSED:  'paused',
  token_expired:   'token expired',
};

const StatusChip = ({ status, size = 'small', sx }) => {
  if (!status) return null;
  return (
    <Chip
      label={LABEL[status] || String(status).toLowerCase().replace(/_/g, ' ')}
      color={COLORS[status] || 'default'}
      size={size}
      sx={{ textTransform: 'capitalize', fontWeight: 500, ...sx }}
    />
  );
};

export default StatusChip;
